/**
 * Иконки — один инлайн SVG-спрайт без пакета.
 *
 * Сетка 16×16, обводка 1,5, скруглённые концы, цвет — currentColor:
 * иконка берёт цвет текста рядом и переключается с темой сама.
 * Спрайт вставляется один раз (App), иконки ссылаются на символ через <use>.
 * Политика содержимого (src/http/network.ts) этому не мешает: всё внутри страницы.
 */

import type { CSSProperties } from 'react'

const PATHS = {
  overview: '<rect x="2" y="2" width="5" height="5" rx="1"/><rect x="9" y="2" width="5" height="5" rx="1"/><rect x="2" y="9" width="5" height="5" rx="1"/><rect x="9" y="9" width="5" height="5" rx="1"/>',
  pnl: '<path d="M4 2h8v12l-2-1.2L8 14l-2-1.2L4 14z"/><path d="M6 5.5h4M6 8.5h4"/>',
  cash: '<path d="M5 13V3M2.5 5.5 5 3l2.5 2.5M11 3v10M8.5 10.5 11 13l2.5-2.5"/>',
  debts: '<circle cx="8" cy="8" r="6"/><path d="M8 4.5V8l2.5 1.5"/>',
  margin: '<circle cx="8" cy="8" r="6"/><path d="M8 2v6h6"/>',
  summary: '<path d="M2.5 7.5 8 3l5.5 4.5"/><path d="M4 6.5V13h8V6.5"/><path d="M6.5 13V9.5h3V13"/>',
  user: '<circle cx="8" cy="5.5" r="2.5"/><path d="M3 13.5c.6-2.4 2.6-3.5 5-3.5s4.4 1.1 5 3.5"/>',
  users: '<circle cx="6" cy="5.5" r="2.2"/><path d="M1.8 13c.5-2.1 2.1-3.2 4.2-3.2s3.7 1.1 4.2 3.2"/><path d="M10.5 3.5a2.2 2.2 0 0 1 0 4.2M11.6 9.9c1.4.4 2.3 1.5 2.6 3.1"/>',
  channels: '<path d="M8 14V9L3.5 4.5M8 9l4.5-4.5"/><path d="M3 7V3.5h3.5M13 7V3.5H9.5"/>',
  stock: '<path d="M2.5 5 8 2.5 13.5 5v6L8 13.5 2.5 11z"/><path d="M2.5 5 8 7.5 13.5 5M8 7.5v6"/>',
  turnover: '<path d="M13 8a5 5 0 0 1-8.6 3.5M3 8a5 5 0 0 1 8.6-3.5"/><path d="M11.8 2v2.6H9.2M4.2 14v-2.6h2.6"/>',
  reports: '<rect x="2" y="2.5" width="12" height="11" rx="1.5"/><path d="M2 6h12M6 6v7.5"/>',
  data: '<ellipse cx="8" cy="4" rx="5" ry="1.8"/><path d="M3 4v8c0 1 2.2 1.8 5 1.8s5-.8 5-1.8V4M3 8c0 1 2.2 1.8 5 1.8s5-.8 5-1.8"/>',
  upload: '<path d="M8 10V2.5M5 5.5l3-3 3 3"/><path d="M2.5 10v2.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V10"/>',
  download: '<path d="M8 2.5V9M5 6l3 3 3-3"/><path d="M2.5 10v2.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V10"/>',
  access: '<rect x="2" y="2" width="12" height="12" rx="1.5"/><path d="M2 6h12M6 2v12"/><path d="m8.5 10 1.3 1.3 2.4-2.6"/>',
  'user-cog': '<circle cx="6.5" cy="5.5" r="2.5"/><path d="M2 13.5c.5-2.3 2.3-3.5 4.5-3.5 1 0 1.9.2 2.6.7"/><circle cx="12" cy="11.5" r="1.4"/><path d="M12 8.9v1.2M12 12.9v1.2M9.4 11.5h1.2M13.4 11.5h1.2"/>',
  rules: '<circle cx="4" cy="3.5" r="1.5"/><circle cx="4" cy="12.5" r="1.5"/><circle cx="12" cy="5.5" r="1.5"/><path d="M4 5v6M12 7c0 2.6-3.2 2.8-6.6 4.6"/>',
  key: '<circle cx="5" cy="11" r="2.8"/><path d="M7 9 13 3M11 5l1.8 1.8M9.4 6.6l1.3 1.3"/>',
  log: '<path d="M2.8 8a5.2 5.2 0 1 0 1.6-3.8"/><path d="M2.5 2.5v2.8h2.8"/><path d="M8 5.2V8l2 1.3"/>',
  lock: '<rect x="3" y="7" width="10" height="7" rx="1.5"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2"/>',
  search: '<circle cx="7" cy="7" r="4.5"/><path d="m10.5 10.5 3 3"/>',
  sun: '<circle cx="8" cy="8" r="2.8"/><path d="M8 1.5V3M8 13v1.5M1.5 8H3M13 8h1.5M3.4 3.4l1 1M11.6 11.6l1 1M3.4 12.6l1-1M11.6 4.4l1-1"/>',
  moon: '<path d="M13 9.5A5.5 5.5 0 1 1 6.5 3a4.5 4.5 0 0 0 6.5 6.5z"/>',
  monitor: '<rect x="2" y="2.5" width="12" height="8.5" rx="1.5"/><path d="M6 14h4M8 11v3"/>',
  'chevron-left': '<path d="m10 3.5-4.5 4.5 4.5 4.5"/>',
  'chevron-right': '<path d="m6 3.5 4.5 4.5L6 12.5"/>',
  'chevron-down': '<path d="m4 6 4 4 4-4"/>',
  check: '<path d="m3 8.5 3 3 7-7"/>',
  x: '<path d="m4 4 8 8M12 4l-8 8"/>',
  info: '<circle cx="8" cy="8" r="6"/><path d="M8 7.3V11M8 5h.01"/>',
  alert: '<circle cx="8" cy="8" r="6"/><path d="M8 4.8v3.7M8 11h.01"/>',
  warning: '<path d="M8 2.2 14.2 13H1.8z"/><path d="M8 6.5v3M8 11.3h.01"/>',
  'arrow-right': '<path d="M3 8h10M9 4l4 4-4 4"/>',
  'arrow-left': '<path d="M13 8H3M7 4 3 8l4 4"/>',
  pin: '<path d="M8 14s4.5-4.2 4.5-7.5a4.5 4.5 0 0 0-9 0C3.5 9.8 8 14 8 14z"/><circle cx="8" cy="6.5" r="1.6"/>',
  more: '<circle cx="3.5" cy="8" r=".9" fill="currentColor"/><circle cx="8" cy="8" r=".9" fill="currentColor"/><circle cx="12.5" cy="8" r=".9" fill="currentColor"/>',
  logout: '<path d="M6 13.5H3.5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1H6"/><path d="M10 11l3-3-3-3M13 8H6"/>',
  filter: '<path d="M2 3.5h12M4.5 8h7M7 12.5h2"/>',
  menu: '<path d="M2.5 4h11M2.5 8h11M2.5 12h11"/>',
  eye: '<path d="M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z"/><circle cx="8" cy="8" r="2"/>',
  external: '<path d="M9 2.5h4.5V7M13.5 2.5 7 9M11.5 9.5v3a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3"/>',
  file: '<path d="M9 2H4.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V5.5z"/><path d="M9 2v3.5h3.5"/>',
  // Пустой лоток, а не пунктирный круг: тот читался как индикатор загрузки.
  empty: '<path d="M2.5 9.5 4.2 3.5h7.6l1.7 6v3h-11z"/><path d="M2.5 9.5h3.2l.8 1.5h3l.8-1.5h3.2"/>',
  'tri-up': '<path d="M8 4.5 12.5 11h-9z" fill="currentColor" stroke="none"/>',
  'tri-down': '<path d="M8 11.5 3.5 5h9z" fill="currentColor" stroke="none"/>',
  dot: '<circle cx="8" cy="8" r="2" fill="currentColor" stroke="none"/>',
  command: '<path d="M5.5 10.5h5v-5h-5zM5.5 5.5V4A1.5 1.5 0 1 0 4 5.5h1.5zM10.5 5.5V4A1.5 1.5 0 1 1 12 5.5h-1.5zM5.5 10.5V12A1.5 1.5 0 1 1 4 10.5h1.5zM10.5 10.5V12a1.5 1.5 0 1 0 1.5-1.5h-1.5z"/>',
} as const

export type IconName = keyof typeof PATHS

/** Один раз на странице, до первого использования. */
export function IconSprite() {
  const symbols = Object.entries(PATHS)
    .map(([name, body]) => `<symbol id="i-${name}" viewBox="0 0 16 16">${body}</symbol>`)
    .join('')
  return <svg className="icon-sprite" aria-hidden="true" focusable="false" dangerouslySetInnerHTML={{ __html: symbols }} />
}

export function Icon({
  name,
  size = 16,
  className,
  style,
  label,
}: {
  name: IconName
  size?: number
  className?: string
  style?: CSSProperties
  /** Подпись для чтения с экрана; без неё иконка декоративная. */
  label?: string
}) {
  return (
    <svg
      className={`icon${className ? ` ${className}` : ''}`}
      width={size}
      height={size}
      style={style}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <use href={`#i-${name}`} />
    </svg>
  )
}
